// extracted by mini-css-extract-plugin
export default {"container":"Card_container__q4M9+","CTA":"Card_CTA__MXvBo"};